import * as React from "react";

import {BrandedLoginForm}       from "./branded-login-form/branded-login-form";

import "./branded-background.scss";

export const BrandedBackground = ({routerHistory, themeScheme}) => {
    const [index, setIndex] = React.useState(0)

    React.useEffect(() => {
        const interval = setInterval(() => {
            const indexNext = (index + 1) % backgrounds.length
            setIndex(indexNext)
        }, DURATION_CAROUSEL_IMAGE)

        return () => clearInterval(interval)
    })

    return (
        <div 
            className="image-br1"
            style={{
                backgroundColor: themeScheme?.xpresso?.menuBackgroundColor
            }}
        >
            {backgroundImages({themeScheme, index})}
            <BrandedLoginForm routerHistory={routerHistory} themeScheme={themeScheme} />
        </div>
    )
}

const backgroundImages = ({themeScheme, index}) => {
    if(themeScheme?.schemeLevelId === ID_COMPANY_HOMEVESTORS) {
        const carouselMax = 3
        if(backgrounds.length < carouselMax) {
            backgrounds.push(carousel(2, null, null, null, `/next_images/landing_page/c7448db0/bg-rotate-3-HV.jpg`))
        }
    }

    return (
        <>
            {
                backgrounds.map((background) => (
                    <React.Fragment key={background.index}>
                        <img 
                            src={sourceXDLogo} 
                            alt="xd-logo"
                            className="xd-logo" 
                        />
                        <img 
                            src={background.source} 
                            alt="background-image" 
                            className={`background ${index === background.index ? "show" : "hide"}`}
                        />
                        <div className="message">
                            <h4 className={index === background.index ? "show" : "hide"} xd-qa-type="text" xd-qa-name="Main Title 1"
                            >
                                {background.headerTop}
                            </h4>
                            <h4 className={index === background.index ? "show" : "hide"} xd-qa-type="text" xd-qa-name="Main Title 2"
                            >
                                {background.headerBottom}
                            </h4>
                            <p className={index === background.index ? "show" : "hide"} xd-qa-type="text" xd-qa-name="Main Body">
                                {background.text}
                            </p>
                        </div>
                    </React.Fragment>
                ))
            }
        </>

    )
}

const carousel = (index, headerTop, headerBottom, text, source) => {
    return {
        'index': index,
        'headerTop': headerTop,
        'headerBottom': headerBottom,
        'text': text,
        'source': source
    }
}

const backgrounds = [
    carousel(0, 
        'High-Quality',
        'Solutions', 
        `Experience unmatched agency-quality designs that can be produced within a matter of minutes.`,
        `/next_images/landing_page/bg-rotate-1.jpg`
        ),
    carousel(1, 
        'Best-in-class',
        'Customer Service',
        `We're here to help! Our Dedicated client support agents are available Monday through Friday by phone, 
        email, and live chat to help you with your order.`,
        `/next_images/landing_page/bg-rotate-2.jpg`
    )
]

const sourceXDLogo = '/next_images/landing_page/XDlogo.png'
const DURATION_CAROUSEL_IMAGE = 5000
const ID_COMPANY_HOMEVESTORS = 'c7448db0'
